<div class="table-container">
  @if (activityListService.itemsCount) {
    <table mat-table #table [dataSource]="activityListService.itemList" matSort matSortActive="claimCreateDate"
      matSortDirection="desc" matSortDisableClear multiTemplateDataRows>
      <ng-container matColumnDef="caseReference" sticky>
        <th mat-header-cell mat-sort-header *matHeaderCellDef>Case Reference</th>
        <td mat-cell matTooltip="{{ row.dataModel.reference }}" matTooltipDelay="750" matTooltipPosition="above"
          *matCellDef="let row">
          <a [routerLink]="['/my-cases', row.dataModel.id]">{{
            row.dataModel.reference
          }}</a>
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>Name</th>
        <td mat-cell matTooltip="{{ row.dataModel.name }}" matTooltipDelay="750" matTooltipPosition="above"
          *matCellDef="let row">
          {{ row.dataModel.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="createdByInitials">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>Created By</th>
        <td mat-cell matTooltip="{{ row.dataModel.createdBy }}" matTooltipDelay="750" matTooltipPosition="above"
          *matCellDef="let row">
          <span class="createdbyDot">{{ row.dataModel.createdByInitials }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="claimCreateDate">
        <th mat-header-cell mat-sort-header *matHeaderCellDef start="desc">Create Date</th>
        <td mat-cell *matCellDef="let row">
          {{ row.dataModel.claimCreateDate | date: 'dd/MM/yyyy HH:mm' }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="selectRow(row); toggleExpanded(row)"
      class="table-data-row" [ngClass]="{ 'table-row-selected': row.dataModel.id == selectedRowId }"></tr>
    </table>
  }

  @if (activityListService.itemsCount <= 0) {
    <div class="fx-layout-align-center-m fx-layout-align-center-x case-list-message"
      >
      <label>
        You currently have no open cases.
      </label>
    </div>
  }

</div>